import { type ApiErrorResponse } from "@/config/apiClient.types";
import { useToasts as getToaster } from "@/hooks";
import { tolgee } from "@/providers/TranslationProvider";

export const handleReactQueryErrors = (
  error: Error | ApiErrorResponse,
  customProcessError?: (e: Error | ApiErrorResponse) => void
) => {
  const toaster = getToaster();

  if (customProcessError?.(error)) {
    return;
  }

  if (handleGlobalError(error)) {
    return;
  }

  toaster.add({
    state: "error",
    title: tolgee.t("toast.generic.error"),
  });
};

const handleGlobalError = (error: Error | ApiErrorResponse) => {
  const toaster = getToaster();

  if (error.message === "refresh_token_failed") {
    if (
      !toaster.queue.visibleToasts.find(
        (e) => e.content.key === "refresh_token_failed"
      )
    ) {
      toaster.add({
        state: "error",
        key: "refresh_token_failed",
        title: tolgee.t("toast.generic.refreshSession"),
      });
    }
    return true;
  }
  if ("status" in error) {
    // Handle and ignore error in case of suggested redirect (wrong workspace)
    if (error?.response?.data?.cause?.suggestedFixData) {
      return true;
    }

    if (error.status === 500) {
      toaster.add({
        state: "error",
        title: tolgee.t("toast.generic.error500"),
      });
      return true;
    }
    if (error.status === 401) {
      toaster.add({
        state: "error",
        title: tolgee.t("toast.generic.error401"),
      });
      return true;
    }
    if (error.status === 403) {
      toaster.add({
        state: "error",
        title: tolgee.t("toast.generic.error403"),
      });
      return true;
    }
    return false;
  }
};
